import React, { Component } from "react";


export default class Contact extends Component {
  render() {
    const fun = 'aloha';
    return (
      <div style={{ textAlign: 'center', padding: '10%' }}>
        <h2 >
          {/* <a style={{ color: 'rgb(29, 185, 84)' }} href="mailto:business.xsell@gmail.com?subject = Introductions&body = Message">
            business.xsell@gmail.com
</a> */}
          <a href={`mailto:business.xsell@gmail.com?&subject=Inquiry&body=`} rel="EMAIL">Email us</a>

        </h2>
      </div>
    )
  }
}


